import { useQueryClient } from "@tanstack/react-query";

/**
 * Hook to get vehicle nameplate, year and trim data from cached order data
 * @param {string} orderId - The order ID
 * @returns {{ nameplate: string, modelYear: string, trim: string }} Vehicle data object
 */
export function useVehicleData(orderId) {
  const queryClient = useQueryClient();

  // Get data from cache
  const orderData = queryClient.getQueryData(["order", { orderId }]);

  if (!orderData?.customerReservation) {
    return {
      nameplate: null,
      modelYear: null,
      trim: null,
    };
  }

  const { customerReservation } = orderData;

  return {
    nameplate: customerReservation.nameplate || null,
    modelYear: customerReservation.modelYear || null,
    trim: customerReservation.trim || null,
  };
}
